import React, { useEffect, useMemo, useState } from "react";
import "devextreme/dist/css/dx.light.css"; // Importe o estilo do DevExtreme
import DataGrid, {
  Column,
  MasterDetail,
  Selection,
  Sorting,
  Pager,
  Paging,
  ColumnFixing,
  ColumnChooser,
  Editing,
  HeaderFilter,
  FilterRow,
  SearchPanel,
  Summary,
  GroupItem,
  Grouping,
  TotalItem,
  Scrolling,
  Lookup,
  Export,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import ExcelJS from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid } from "devextreme/excel_exporter";
import "./Grid.scss";
import Loading from "@components/loading/Loading";
import UtilServices from "@services/UtilServices";

export default function Grid({
  filterHeader = true,
  columns = [],
  searchPanel = true,
  filterSearch = true,
  filterRow = true,
  exportExcel = true,
  data = [],
  showRowLines = true,
  columnSelector = true,
  summary = true,
  paging = true,
  pageVisible = "auto",
  pagingStaticSize = 10,
  Memo = true,
  dadosGrid = [
    { id: "1", nome: "teste" },
    { id: "2", nome: "teste" },
  ],
  // Selecionador CheckBox
  selection = false,
  onSelectionChanged = () => null,
  selectionMode = "multiple",
  selectionSelectAllMode = "page",
  selectionShowCheckBoxesMode = "onClick",
  onEditorPreparing = () => null,
  //Loading
  useLoading = false,
  //Ref
  refGrid = () => null,
  //Auto width
  columnAutoWidth = true,
  allowColumnResizing = true,
  //Title
  title = "",
  iconTitle = "",
  //
  noDataText = "Sem dados",
  ...props
}) {
  function mapperColumnsGrid(columns) {
    let result = columns.map((e, i) => {
      return <Column key={i} {...e} />;
    });
    return result;
  }
  function onExporting(e) {
    function dataHoje() {
      const data = new Date();
      const dia = String(data.getDate()).padStart(2, "0");
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const ano = data.getFullYear();
      return `${dia}_${mes}_${ano}`;
    }

    let nameFile = props.exportFileName ? props.exportFileName + "_" : "";
    nameFile = nameFile + dataHoje();

    if (props.exportCsvLargeSize && data?.length > 100000) {
      exportToCsv(`${nameFile}.csv`, data);
      e.cancel = true;
    } else {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Main sheet");

      exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], {
              type: "application/octet-stream",
            }),
            `${nameFile}.xlsx`,
          );
        });
      });
      e.cancel = true;
    }
  }
  function exportToCsv(filename, rows) {
    var processRow = function (row) {
      var finalVal = "";
      for (var j = 0; j < row.length; j++) {
        var innerValue = row[j] === null ? "" : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        }
        var result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
        if (j > 0) finalVal += ";";
        finalVal += result;
      }
      return finalVal + "\n";
    };

    var csvFile = "";
    for (var i = 0; i < rows.length; i++) {
      let row = Object.values(rows[i]);
      csvFile += processRow(row);
    }

    let header = processRow(Object.keys(rows[0]));
    csvFile = header + csvFile;

    var blob = new Blob(["\uFEFF" + csvFile], {
      type: "text/csv; charset=utf-18",
    });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
  function renderGrid() {
    return (
      <div className="dataGrid">
        {useLoading === true ? (
          <div className="dataGrid-loading">
            <Loading color="#c1abff" show={useLoading} individual={true} />
          </div>
        ) : (
          <DataGrid
            columnAutoWidth={columnAutoWidth}
            allowColumnResizing={allowColumnResizing}
            columnResizingMode="widget"
            ref={refGrid}
            noDataText={noDataText}
            dataSource={dadosGrid?.map((item, index) => ({
              ...item,
              IDGrid: index,
            }))}
            onExporting={onExporting}
            showRowLines={showRowLines}
            {...(summary && {
              summary: summary,
            })}
            {...(props.onCellPrepared && {
              onCellPrepared: props.onCellPrepared,
            })}
            {...(onEditorPreparing && {
              onEditorPreparing: onEditorPreparing,
            })}
            // Selecionador CheckBox
            {...(typeof selection === "object" && {
              onSelectionChanged: onSelectionChanged,
              selection: selection,
            })}
          >
            {/* Configurar colunas */}
            {columns?.length > 0 && mapperColumnsGrid(columns)}
            {filterHeader && (
              <HeaderFilter
                visible={true}
                texts={{
                  cancel: "Cancelar",
                  emptyValue: "Vazio",
                }}
                allowSearch={true}
              />
            )}
            {/* exibir a barra de pesquisa */}
            {searchPanel && (
              <SearchPanel visible={true} placeholder="Pesquisar" />
            )}
            {/* exibir os filtror */}
            {(filterRow || filterSearch) && (
              <FilterRow
                visible={true}
                operationDescriptions={{
                  between: "Entre",
                  contains: "Contém",
                  endsWith: "Termina com",
                  equal: "Igual",
                  greaterThan: "Maior que",
                  greaterThanOrEqual: "Maior que ou igual",
                  lessThan: "Menor que",
                  lessThanOrEqual: "Menor ou igual",
                  notContains: "Não contém",
                  notEqual: "Não igual",
                  startsWith: "Começa com",
                }}
                resetOperationText="Limpar"
                showAllText="Tudo"
              />
            )}
            {/* exibir o export em excel */}
            {exportExcel && (
              <Export
                enabled={true}
                allowExportSelectedData={false}
                texts={{
                  exportAll: "Exportar Planilha (Excel)",
                }}
              />
            )}
            {/* exibir selecao de colunas */}
            {columnSelector && (
              <ColumnChooser
                enabled={true}
                emptyPanelText="Arraste uma coluna aqui para ocultá-la"
                title="Seletor de coluna"
              />
            )}
            {/* exibe a paginacao estática */}
            {paging === true ? (
              <Paging defaultPageSize={pagingStaticSize} />
            ) : (
              <Paging enabled={false} />
            )}
            {paging && (
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[5, 10, 20, 50, 100, 500]}
                showInfo={true}
                infoText="Página {0} de {1} ({2} itens)"
                visible={pageVisible}
                showNavigationButtons={true}
              />
            )}
            {/* Exibir CheckBox de Selecao */}
            {selection === true && (
              <Selection
                mode={selectionMode}
                selectAllMode={selectionSelectAllMode}
                showCheckBoxesMode={selectionShowCheckBoxesMode}
                allowSelectAll={true}
              />
            )}
          </DataGrid>
        )}
      </div>
    );
  }
  const gridMemo = useMemo(() => {
    return renderGrid();
  }, [dadosGrid]);

  return (
    <div className={`containerGrid ${props.className}`}>
      {title && !iconTitle && <p className="title">{title}</p>}
      {title && iconTitle && (
        <div
          className="title"
          style={{
            marginBottom:
              !exportExcel || !columnSelector || !searchPanel ? "30px" : "",
          }}
        >
          <span>{UtilServices.renderIcon(iconTitle)}</span>
          <p>{title}</p>
        </div>
      )}

      {Memo ? gridMemo : renderGrid()}
    </div>
  );
}
